module.exports = __webpack_public_path__ + "static/sales-customer-journey-f3488a0b20659b7e8ed97543bcbaa4b3.png";